import { gql } from '@apollo/client';

const START_USER_FLOW_STEP_USING_URLS_MUTATION = gql`
  mutation startUserFlowStepUsingUrls($userFlowStepUrl: String!, $userFlowUrl: String!) {
    userFlowStepTrack {
      startUserFlowStepUsingUrls(userFlowStepUrl: $userFlowStepUrl, userFlowUrl: $userFlowUrl) {
        id
      }
    }
  }
`;

export { START_USER_FLOW_STEP_USING_URLS_MUTATION };
